import { RootState } from '../redux';

export const selectConfiguration = (state: RootState) => state.configuration;
